// Client-side public surface: what other modules may use.

import { lazyView } from "@/platform/client";

export const AccountsPage = lazyView(() =>
  import("./ui/accounts/AccountsPage.js").then((m) => m.AccountsPage),
);
export const AnalyticsPage = lazyView(() =>
  import("./ui/analytics/AnalyticsPage.js").then((m) => m.AnalyticsPage),
);
export const CashFlowPage = lazyView(() =>
  import("./ui/cashflow/CashFlowPage.js").then((m) => m.CashFlowPage),
);
export const CategorizePage = lazyView(() =>
  import("./ui/cashflow/CategorizePage.js").then((m) => m.CategorizePage),
);
export const MarketPage = lazyView(() =>
  import("./ui/market/MarketPage.js").then((m) => m.MarketPage),
);
export const PortfolioPage = lazyView(() =>
  import("./ui/portfolio/PortfolioPage.js").then((m) => m.PortfolioPage),
);
export const StrategyPage = lazyView(() =>
  import("./ui/strategy/StrategyPage.js").then((m) => m.StrategyPage),
);
export { marketNotifications } from "./ui/notifications.js";
export { dashboardQueries } from "./ui/queries/dashboards.js";
